// Central business configuration — edit here, not inside components.
// Anything marked "placeholder" awaits owner approval.

export const site = {
  name: "HairByYaya",
  tagline: "YAYA JUST DID THAT",
  subline: "Braids • Protective Styles • Hampton, VA",
  promise: "Beautiful braids. Clean parts. Confident looks.",
  instagram: {
    handle: "@hairbyyaya_didthat",
    url: "https://instagram.com/hairbyyaya_didthat",
  },
  location: "Hampton, Virginia",
  locationNote:
    "Exact appointment location will be provided to confirmed clients.",
  email: "hello@hairbyyaya.com", // placeholder email — owner to confirm
  deposit: 25, // flat deposit, shown in the simulated booking flow
  year: 2026,
  // When the real Jotform booking form exists, set REACT_APP_JOTFORM_BOOKING_URL
  // in frontend/.env and the BookingEmbed component swaps to production mode.
  jotformBookingUrl: process.env.REACT_APP_JOTFORM_BOOKING_URL || "",
  nav: [
    { label: "Home", to: "/" },
    { label: "Services", to: "/services" },
    { label: "Gallery", to: "/gallery" },
    { label: "About", to: "/about" },
    { label: "Policies", to: "/policies" },
    { label: "Contact", to: "/contact" },
  ],
  assets: {
    logoScript: "/assets/brand/LOGO-1.png",
    logoMark: "/assets/brand/LOGO.png",
    qr: "/assets/brand/ig-qr.jpeg",
    promoPost: "/assets/brand/ig-feedin-promo.png",
    toolsPost: "/assets/brand/ig-tools-flatlay.png",
  },
};

export const bookUrl = (serviceId) =>
  serviceId ? `/book?service=${serviceId}` : "/book";
